export enum ApplicationEnvironment {

    // Obsolete
    Nightly = 'night',
    Regression = 'reg',
    Staging = 'stag',

    /** The kind k8s is like dev but on a local k8s cluster. */
    Kind = 'kind',
    Development = 'dev',
    Edge = 'edge',
    Vnext = 'vnext',
    ReleaseCandidate = 'rc',
    Hotfix = 'hot',
    Production = 'prod',

}

export enum AppName {
    FieldApp = 'FieldApp',
    ManagerApp = 'ManagerApp',
}
